import { render, staticRenderFns } from "./NoteCenterPreview.vue?vue&type=template&id=63aa17e6&scoped=true"
import script from "./NoteCenterPreview.vue?vue&type=script&lang=js"
export * from "./NoteCenterPreview.vue?vue&type=script&lang=js"
import style0 from "./NoteCenterPreview.vue?vue&type=style&index=0&id=63aa17e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aa17e6",
  null
  
)

export default component.exports